var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1544",
    cx: 7.08301,
    cy: 7.75,
    r: 1.25,
    stroke: "#1C1C1E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1545",
    cx: 12.083,
    cy: 11.9166,
    r: 1.25,
    stroke: "#1C1C1E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1546",
    cx: 15.4165,
    cy: 5.25,
    r: 1.25,
    stroke: "#1C1C1E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8617 10.9136L15 6.5M7.98543 8.64037L11.0032 10.9136M2.5 14.8333L6.32464 8.89933",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 338",
    d: "M16.6665 16.5H7.49984C4.74998 16.5 3.37505 16.5 2.52078 15.6457C1.6665 14.7915 1.6665 13.4165 1.6665 10.6667V1.5",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.0415386c92759bc3e4e9ebdde9ffaec8.svg";
export { ForwardRef as ReactComponent };